module.exports = __webpack_public_path__ + "img/icon-money.cd4ed26c.svg";